import { Component, OnInit, ViewChild} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import {DateAdapter} from '@angular/material/core';
import {TranslateService} from 'ng2-translate/ng2-translate';
import { GeneralService } from '../../services/general.service';
import { GroupService } from '../../services/group.service';
import {ModalConfirmComponent} from '../../modal-confirm/modal-confirm.component';

@Component({
  selector: 'app-invoices-payments',
  templateUrl: './invoices-payments.component.html',
  styleUrls: ['./invoices-payments.component.scss']
})
export class InvoicesPaymentsComponent implements OnInit {
  @ViewChild('fileInvView', { static: false }) fileInvView;
  userId: any;
  userToken: any;
  temp = [];
  load = true;
  data: any = {};
  filterd: any = {};
  typeFileUpload: any;
  step = 0;
  totalrows = 5150;

  listOc = [
    {id: 13, code: 100000, name: 'Proveedor 1', number: 392689, type: 'Factura', total: 300, date: '2018-05-25', currency: 'MXN'},
    {id: 13, code: 103405, name: 'Proveedor 2', number: 132659, type: 'Nota de Crédito', total: 1300, date: '2018-03-22', currency: 'MXN'},
    {id: 13, code: 103404, name: 'Proveedor 3', number: 692779, type: 'Factura', total: 3300, date: '2018-03-22', currency: 'MXN'}
  ];

  constructor(private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private groupService: GroupService, public translate: TranslateService, private adapter: DateAdapter<any>) {
    //const b = JSON.parse(decodeURIComponent(localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352')));
    //this.userId = b['id'];
    //this.userToken = b['session_token'];
    this.temp = this.listOc;
    gralService.changeTextHead('INVOICEPAYMENTS');

    translate.onLangChange.subscribe(lang => {
      if(lang.lang == 'en'){
        this.adapter.setLocale('en-GB');
      }

      if(lang.lang == 'es'){
        this.adapter.setLocale('es-MX');
      }
    });
  }

  ngOnInit() {
  }

  search(){
    if(!this.data.init || !this.data.end || !this.data.provider || !this.data.partida){
      this.toastr.error('Favor de ingresar todos los campos', 'Error');
      return;
    }

    this.step = 1;
  }

  searchFilter(){
    if(!this.filterd.provider && !this.filterd.type){
      this.toastr.error('Favor de ingresar algun parametro de busqueda', 'Error');
      return;
    }

    const ret = [];
    const valp = this.filterd.provider;
    const valt = this.filterd.type;

    for(let i = 0; i < this.listOc.length; i++){
      if(valp){
        if(valt){
          if(this.listOc[i].code == valp && this.listOc[i].type == valt){
            ret.push(this.listOc[i]);
          }
        }else{
          if(this.listOc[i].code == valp){
            ret.push(this.listOc[i]);
          }else{
            if(this.listOc[i].type == valt){
              ret.push(this.listOc[i]);
            }
          }
        }
      }else{
        if(this.listOc[i].type == valt){
          ret.push(this.listOc[i]);
        }
      }
    }
    this.listOc = ret;
  }

  reinit(){
    this.filterd.provider = null;
    this.filterd.type = null;
    this.listOc = this.temp;
  }

}
